import crossFetch from 'cross-fetch';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { getConfig } from '@chegg-web-tools/config-plugin';
import { getGqlUrl } from '@chegg/utils';
import { APP_ID, RIO_CONFIG } from '../../types';
import { authLink } from '../shared';

// setup Appolo client with in-memory caching, calling the onegraphEndpoint GraphQL endpoint
var apolloClient = function apolloClient() {
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(createHttpLink({
      uri: getGqlUrl(window.location.hostname, undefined, 'rio2-web-client'),
      credentials: 'include',
      headers: {
        'apollographql-client-name': getConfig(RIO_CONFIG)[APP_ID],
        'apollographql-client-version': 'v1'
      },
      fetchOptions: {
        credentials: 'include'
      },
      fetch: crossFetch
    }))
  });
};
export default apolloClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/client/https/apolloClient.js
// module id = 4144
// module chunks = 11